<template>
  <transition
    enter-active-class="transition-opacity"
    leave-active-class="transition-opacity"
    enter-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <div class="chatbot-widget" :class="{'chat-started': chatStarted}">
      <div class="chatbot-widget__header" :class="{'chatbot-widget__fixed': chatStarted}">
        <div class="chatbot-widget__header__left" :class="{'justify-content-center': chatStarted}">
          <div class="chatbot-widget__header__left__icon" v-if="!chatStarted">
            <img v-if="hasChatIcon" :src="getChatIcon" :alt="campaign.display_name + ' Logo'">
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
              <g clip-path="url(#clip0_1844_64)">
                <path d="M3.39844 0H14.9902C15.8908 0.00257664 16.7537 0.361453 17.3904 0.998226C18.0272 1.635 18.3861 2.49791 18.3887 3.39844V10.875C18.3861 11.7755 18.0272 12.6384 17.3904 13.2752C16.7537 13.912 15.8908 14.2709 14.9902 14.2734H9.21094L4.13281 18.6406C4.00992 18.745 3.85069 18.7964 3.68998 18.7835C3.52928 18.7707 3.3802 18.6948 3.27539 18.5723C3.22275 18.5132 3.18235 18.4443 3.15653 18.3696C3.13072 18.2948 3.12 18.2157 3.125 18.1367L3.39062 14.2734C2.49145 14.2688 1.63054 13.909 0.995454 13.2725C0.360366 12.6359 0.00256452 11.7742 0 10.875L0 3.39844C0.00257664 2.49791 0.361453 1.635 0.998226 0.998226C1.635 0.361453 2.49791 0.00257664 3.39844 0ZM13.0117 6.08203C13.2435 6.08203 13.4701 6.15076 13.6628 6.27953C13.8555 6.4083 14.0057 6.59132 14.0944 6.80545C14.1831 7.01958 14.2063 7.25521 14.1611 7.48253C14.1159 7.70985 14.0042 7.91866 13.8404 8.08255C13.6765 8.24644 13.4677 8.35805 13.2403 8.40326C13.013 8.44848 12.7774 8.42527 12.5633 8.33658C12.3491 8.24788 12.1661 8.09768 12.0373 7.90497C11.9086 7.71225 11.8398 7.48568 11.8398 7.25391C11.8398 6.94311 11.9633 6.64503 12.1831 6.42527C12.4028 6.2055 12.7009 6.08203 13.0117 6.08203ZM9.19336 6.08203C9.42513 6.08203 9.6517 6.15076 9.84442 6.27953C10.0371 6.4083 10.1873 6.59132 10.276 6.80545C10.3647 7.01958 10.3879 7.25521 10.3427 7.48253C10.2975 7.70985 10.1859 7.91866 10.022 8.08255C9.85811 8.24644 9.6493 8.35805 9.42198 8.40326C9.19466 8.44848 8.95903 8.42527 8.7449 8.33658C8.53077 8.24788 8.34775 8.09768 8.21898 7.90497C8.09021 7.71225 8.02148 7.48568 8.02148 7.25391C8.02148 6.94311 8.14495 6.64503 8.36472 6.42527C8.58449 6.2055 8.88256 6.08203 9.19336 6.08203ZM5.37695 6.08203C5.60873 6.08203 5.8353 6.15076 6.02801 6.27953C6.22073 6.4083 6.37093 6.59132 6.45962 6.80545C6.54832 7.01958 6.57153 7.25521 6.52631 7.48253C6.48109 7.70985 6.36948 7.91866 6.20559 8.08255C6.0417 8.24644 5.8329 8.35805 5.60557 8.40326C5.37825 8.44848 5.14263 8.42527 4.9285 8.33658C4.71436 8.24788 4.53134 8.09768 4.40257 7.90497C4.27381 7.71225 4.20508 7.48568 4.20508 7.25391C4.20508 6.94311 4.32854 6.64503 4.54831 6.42527C4.76808 6.2055 5.06615 6.08203 5.37695 6.08203ZM19.9883 5.49609C20.7383 5.64147 21.4145 6.04297 21.9012 6.63191C22.3879 7.22084 22.6548 7.9606 22.6562 8.72461V16.2109C22.6511 17.0797 22.303 17.9113 21.6878 18.5247C21.0725 19.1382 20.2399 19.4838 19.3711 19.4863H19.252L19.5273 23.4707C19.5356 23.5999 19.4936 23.7272 19.4102 23.8262C19.3247 23.9261 19.203 23.988 19.0719 23.9983C18.9408 24.0085 18.8109 23.9663 18.7109 23.8809L13.5996 19.3574H6.86914L10.1895 15.9863H17.2207C17.9591 15.9838 18.6665 15.6893 19.1886 15.1672C19.7108 14.645 20.0052 13.9376 20.0078 13.1992V5.7207C20.0078 5.64648 20.0078 5.57227 20.0078 5.5L19.9883 5.49609ZM14.9902 1.2207H3.39844C2.82134 1.22225 2.26832 1.45219 1.86026 1.86026C1.45219 2.26832 1.22225 2.82134 1.2207 3.39844V10.875C1.22225 11.4521 1.45219 12.0051 1.86026 12.4132C2.26832 12.8213 2.82134 13.0512 3.39844 13.0527H4.08789C4.24909 13.0638 4.39936 13.1382 4.50587 13.2597C4.61237 13.3812 4.66644 13.5399 4.65625 13.7012L4.44336 16.7656L8.55664 13.2305C8.67099 13.1171 8.82532 13.0533 8.98633 13.0527H14.9902C15.567 13.0502 16.1194 12.8199 16.5273 12.4121C16.9351 12.0042 17.1654 11.4518 17.168 10.875V3.39844C17.1654 2.82166 16.9351 2.26923 16.5273 1.86139C16.1194 1.45354 15.567 1.22327 14.9902 1.2207Z" fill="black"/>
              </g>
              <defs>
                <clipPath id="clip0_1844_64">
                  <rect width="22.6543" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div v-else class="header-icon back-icon" @click.stop="goBack()">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
              <path d="M8.5 1L1.5 8L8.5 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span v-if="chatStarted">{{campaign.display_name}} Support</span>
          <div class="header-icon close-icon d-flex d-sm-none" @click.stop="$emit('close')">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M13.5 13.5L1.5 1.5M13.5 1.5L1.5 13.5" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
      <template v-if="!chatStarted">
        <div class="chatbot-widget__sub_header">
          <div class="chatbot-widget__sub_header__title">Hello<span v-if="isSessionUserKnown"> {{session.customer.first_name}}</span>!</div>
          <div class="chatbot-widget__sub_header__description">Thanks for giving us the opportunity to help you. Please make your selection below.</div>
        </div>
        <div class="chatbot-widget__content">
          <div class="chatbot-widget__content__quicklinks">
            <div class="chatbot-widget__content__quicklink" @click.stop="toggleChatbot">
              <div class="chatbot-widget__content__quicklink__left">
                <div class="chatbot-widget__content__quicklink__left__title bottom-title">Chat with us</div>
                <div class="chatbot-widget__content__quicklink__left__subtitle">
                  We typically reply within a minute
                </div>
              </div>
              <div class="chatbot-widget__content__quicklink__right">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="message-icon">
                  <path d="M20.2346 5.686C20.6666 4.491 19.5086 3.333 18.3136 3.766L3.70855 9.048C2.50955 9.482 2.36455 11.118 3.46755 11.757L8.12955 14.456L12.2926 10.293C12.4812 10.1108 12.7338 10.01 12.996 10.0123C13.2582 10.0146 13.509 10.1198 13.6944 10.3052C13.8798 10.4906 13.9849 10.7414 13.9872 11.0036C13.9895 11.2658 13.8887 11.5184 13.7066 11.707L9.54355 15.87L12.2436 20.532C12.8816 21.635 14.5176 21.489 14.9516 20.291L20.2346 5.686Z" fill="#009ADE"/>
                </svg>
              </div>
            </div>
          </div>
          <div class="chatbot-widget__content__quicklinks" v-if="quickLinks && quickLinks.length">
            <div class="chatbot-widget__content__quicklink heading">
              <div class="chatbot-widget__content__quicklink__left">
                <div class="chatbot-widget__content__quicklink__left__title top-title">Quick Links</div>
              </div>
            </div>
            <template v-for="quickLink in quickLinks">
              <div class="chatbot-widget__content__quicklink" :key="'quicklink-' + quickLink.id" @click="openLink(quickLink)">
                <div class="chatbot-widget__content__quicklink__left">
                  <div class="chatbot-widget__content__quicklink__left__title">{{ quickLink.title }}</div>
                  <div class="chatbot-widget__content__quicklink__left__subtitle" v-if="quickLink.subtitle">
                    {{quickLink.subtitle}}
                  </div>
                </div>
                <div class="chatbot-widget__content__quicklink__right">
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                  <path d="M1 1L6 6L1 11" stroke="#181818" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              </div>
              <hr  :key="'quicklink-border-' + quickLink.id" />
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="chatbot-widget__body" ref="messagesContainer">
          <div
            v-for="(message, index) in messages"
            :key="index"
            class="chat-message"
            :class="{ 'user-message': message.isUser }"
          >
            <div class="logo" v-if="!message.isUser">
              <img v-if="hasChatIcon" :src="getChatIcon" />
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                <g clip-path="url(#clip0_1844_66)">
                  <path d="M2.83203 0H12.4919C13.2423 0.0021472 13.9614 0.301211 14.492 0.831855C15.0227 1.3625 15.3217 2.08159 15.3239 2.83203V9.0625C15.3217 9.81294 15.0227 10.532 14.492 11.0627C13.9614 11.5933 13.2423 11.8924 12.4919 11.8945H7.67578L3.44401 15.5339C3.3416 15.6208 3.2089 15.6636 3.07498 15.653C2.94106 15.6423 2.81683 15.579 2.72949 15.4769C2.68562 15.4277 2.65196 15.3703 2.63044 15.308C2.60893 15.2457 2.6 15.1797 2.60417 15.1139L2.82552 11.8945C2.07621 11.8907 1.35878 11.5908 0.829545 11.0604C0.300305 10.5299 0.0021371 9.81182 0 9.0625L0 2.83203C0.0021472 2.08159 0.301211 1.3625 0.831855 0.831855C1.3625 0.301211 2.08159 0.0021472 2.83203 0ZM10.8431 5.06836C11.0362 5.06836 11.2251 5.12563 11.3856 5.23294C11.5462 5.34025 11.6714 5.49276 11.7453 5.67121C11.8192 5.84965 11.8386 6.04601 11.8009 6.23544C11.7632 6.42487 11.6702 6.59888 11.5336 6.73546C11.3971 6.87203 11.2231 6.96504 11.0336 7.00272C10.8442 7.0404 10.6478 7.02106 10.4694 6.94715C10.2909 6.87323 10.1384 6.74807 10.0311 6.58747C9.92381 6.42688 9.86654 6.23807 9.86654 6.04492C9.86654 5.78592 9.96942 5.53753 10.1526 5.35439C10.3357 5.17125 10.5841 5.06836 10.8431 5.06836ZM7.66113 5.06836C7.85428 5.06836 8.04309 5.12563 8.20368 5.23294C8.36428 5.34025 8.48944 5.49276 8.56336 5.67121C8.63727 5.84965 8.65661 6.04601 8.61893 6.23544C8.58125 6.42487 8.48824 6.59888 8.35167 6.73546C8.21509 6.87203 8.04109 6.96504 7.85165 7.00272C7.66222 7.0404 7.46586 7.02106 7.28742 6.94715C7.10897 6.87323 6.95646 6.74807 6.84915 6.58747C6.74184 6.42688 6.68457 6.23807 6.68457 6.04492C6.68457 5.78592 6.78746 5.53753 6.9706 5.35439C7.15374 5.17125 7.40213 5.06836 7.66113 5.06836ZM4.48079 5.06836C4.67394 5.06836 4.86275 5.12563 5.02334 5.23294C5.18394 5.34025 5.30911 5.49276 5.38302 5.67121C5.45693 5.84965 5.47627 6.04601 5.43859 6.23544C5.40091 6.42487 5.3079 6.59888 5.17133 6.73546C5.03475 6.87203 4.86075 6.96504 4.67131 7.00272C4.48188 7.0404 4.28552 7.02106 4.10708 6.94715C3.92864 6.87323 3.77612 6.74807 3.66881 6.58747C3.56151 6.42688 3.50423 6.23807 3.50423 6.04492C3.50423 5.78592 3.60712 5.53753 3.79026 5.35439C3.9734 5.17125 4.22179 5.06836 4.48079 5.06836ZM16.6569 4.58008C17.2819 4.70122 17.8455 5.03581 18.251 5.52659C18.6566 6.01737 18.879 6.63384 18.8802 7.27051V13.5091C18.8759 14.2331 18.5859 14.9261 18.0731 15.4373C17.5604 15.9485 16.8666 16.2365 16.1426 16.2386H16.0433L16.2728 19.5589C16.2796 19.6666 16.2447 19.7727 16.1751 19.8551C16.1039 19.9384 16.0025 19.99 15.8932 19.9986C15.784 20.0071 15.6758 19.9719 15.5924 19.9007L11.333 16.1312H5.72428L8.49121 13.3219H14.3506C14.9659 13.3198 15.5554 13.0744 15.9905 12.6393C16.4256 12.2042 16.671 11.6147 16.6732 10.9993V4.76725C16.6732 4.7054 16.6732 4.64355 16.6732 4.58333L16.6569 4.58008ZM12.4919 1.01725H2.83203C2.35112 1.01854 1.89027 1.21015 1.55021 1.55021C1.21015 1.89027 1.01854 2.35112 1.01725 2.83203V9.0625C1.01854 9.54341 1.21015 10.0043 1.55021 10.3443C1.89027 10.6844 2.35112 10.876 2.83203 10.8773H3.40658C3.54091 10.8865 3.66614 10.9485 3.75489 11.0497C3.84364 11.151 3.8887 11.2833 3.88021 11.4176L3.7028 13.9714L7.13053 11.0254C7.22582 10.9309 7.35443 10.8777 7.48861 10.8773H12.4919C12.9725 10.8751 13.4329 10.6833 13.7727 10.3434C14.1126 10.0035 14.3045 9.54315 14.3066 9.0625V2.83203C14.3045 2.35138 14.1126 1.89103 13.7727 1.55115C13.4329 1.21128 12.9725 1.01939 12.4919 1.01725Z" fill="black"/>
                </g>
                <defs>
                  <clipPath id="clip0_1844_66">
                    <rect width="18.8786" height="20" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="d-flex flex-column" :class="{'mb-3': !message.isUser && message.id}">
              <div class="message-text">
                <span v-html="message.text"></span>
                <div class="feedback" v-if="!message.isUser && message.id && index >= 3">
                  <svg @click="sendMessageFeedback(message, 1)" :class="{'has_feedback': message.feedback === 1}" xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.20853 1.77859C9.08764 1.74002 8.95658 1.749 8.84208 1.80369C8.78533 1.82996 8.73499 1.86826 8.69453 1.91594C8.65408 1.96362 8.62449 2.01953 8.60781 2.07979L8.20956 3.61422C8.07044 4.15049 7.86823 4.66837 7.60716 5.15703C7.20138 5.91588 6.58811 6.49903 6.01918 6.98931L4.81607 8.02677C4.72403 8.10616 4.65215 8.20625 4.60633 8.31883C4.56052 8.43141 4.54207 8.55325 4.55252 8.67435L5.23189 16.5331C5.24841 16.724 5.33582 16.9017 5.4769 17.0314C5.61798 17.161 5.8025 17.2331 5.99408 17.2334H9.88372C12.5075 17.2334 14.7188 15.4078 15.143 12.9555L15.7328 9.54196C15.7519 9.43196 15.7468 9.31909 15.7178 9.21128C15.6887 9.10346 15.6365 9.00329 15.5647 8.91778C15.4929 8.83227 15.4033 8.76348 15.3021 8.71623C15.2009 8.66898 15.0906 8.6444 14.979 8.64423H10.6442C9.82682 8.64423 9.20519 7.91131 9.33738 7.10477L9.89208 3.72132C9.96807 3.25788 9.94642 2.78369 9.8285 2.32911C9.79522 2.20877 9.73206 2.0988 9.64487 2.00943C9.55769 1.92005 9.44932 1.85417 9.32985 1.81791L9.20853 1.77859ZM8.29657 0.673363C8.70118 0.478714 9.16503 0.446672 9.59256 0.58384L9.71387 0.623163C10.364 0.832328 10.871 1.35106 11.0433 2.01369C11.2048 2.63784 11.2349 3.28876 11.1303 3.92463L10.5756 7.30808C10.5739 7.31806 10.5744 7.32829 10.5771 7.33806C10.5797 7.34783 10.5845 7.35689 10.5911 7.36462C10.5976 7.37236 10.6057 7.37857 10.6149 7.38282C10.6241 7.38707 10.6341 7.38926 10.6442 7.38924H14.9781C16.2331 7.38924 17.1836 8.5204 16.9694 9.75615L16.3795 13.1697C15.8458 16.2553 13.0848 18.4884 9.88372 18.4884H5.99408C5.4884 18.4879 5.00124 18.298 4.62874 17.956C4.25624 17.614 4.02545 17.1448 3.98191 16.641L3.30171 8.78228C3.27406 8.46312 3.32259 8.14196 3.44332 7.84523C3.56405 7.5485 3.75352 7.28468 3.99614 7.07549L5.20093 6.03803C5.74894 5.56615 6.20994 5.1085 6.49943 4.56551C6.71437 4.1645 6.88064 3.73925 6.99473 3.2988L7.39298 1.76521C7.45526 1.52851 7.56836 1.30822 7.7244 1.11967C7.88045 0.93111 8.0757 0.778811 8.29657 0.673363ZM1.28536 7.39007C1.44705 7.383 1.60522 7.43868 1.72683 7.54548C1.84844 7.65228 1.92408 7.80193 1.93795 7.96319L2.74951 17.3639C2.76326 17.5039 2.74833 17.6452 2.70562 17.7792C2.66292 17.9133 2.59334 18.0372 2.50115 18.1434C2.40895 18.2497 2.29606 18.336 2.16938 18.3971C2.0427 18.4583 1.90488 18.4929 1.76435 18.499C1.62381 18.5051 1.48352 18.4825 1.35202 18.4326C1.22052 18.3826 1.10059 18.3064 0.999537 18.2085C0.898489 18.1107 0.81845 17.9932 0.764307 17.8634C0.710165 17.7336 0.683055 17.5941 0.684636 17.4534V8.01673C0.684488 7.85485 0.746911 7.69917 0.85886 7.58223C0.970809 7.46529 1.12362 7.39698 1.28536 7.39007Z" fill="white"/>
                  </svg>
                  <svg @click="sendMessageFeedback(message, 0)" :class="{'has_feedback': message.feedback === 0}" xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.47555 17.2214C8.59645 17.26 8.7275 17.251 8.84201 17.1963C8.89875 17.17 8.9491 17.1317 8.98955 17.0841C9.03 17.0364 9.0596 16.9805 9.07627 16.9202L9.47452 15.3858C9.61365 14.8495 9.81586 14.3316 10.0769 13.843C10.4827 13.0841 11.096 12.501 11.6649 12.0107L12.868 10.9732C12.9601 10.8938 13.0319 10.7937 13.0777 10.6812C13.1236 10.5686 13.142 10.4467 13.1316 10.3257L12.4522 2.4669C12.4357 2.27603 12.3483 2.09827 12.2072 1.96865C12.0661 1.83903 11.8816 1.76695 11.69 1.76662H7.80036C5.1766 1.76662 2.9653 3.59221 2.54112 6.04446L1.95127 9.45804C1.93213 9.56804 1.93727 9.68091 1.96631 9.78872C1.99535 9.89654 2.0476 9.99671 2.1194 10.0822C2.19121 10.1677 2.28083 10.2365 2.382 10.2838C2.48317 10.331 2.59344 10.3556 2.7051 10.3558H7.03984C7.85726 10.3558 8.4789 11.0887 8.3467 11.8952L7.792 15.2787C7.71601 15.7421 7.73767 16.2163 7.85558 16.6709C7.88886 16.7912 7.95203 16.9012 8.03921 16.9906C8.12639 17.0799 8.23476 17.1458 8.35423 17.1821L8.47555 17.2214ZM9.38751 18.3266C8.9829 18.5213 8.51905 18.5533 8.09152 18.4162L7.97021 18.3768C7.32012 18.1677 6.81311 17.6489 6.64075 16.9863C6.47928 16.3622 6.44916 15.7112 6.55374 15.0754L7.10845 11.6919C7.11015 11.6819 7.10966 11.6717 7.107 11.6619C7.10433 11.6522 7.09957 11.6431 7.09303 11.6354C7.0865 11.6276 7.07835 11.6214 7.06916 11.6172C7.05997 11.6129 7.04996 11.6107 7.03984 11.6108H2.70594C1.45095 11.6108 0.500502 10.4796 0.714687 9.24385L1.30453 5.83028C1.83832 2.74467 4.5993 0.511627 7.80036 0.511627H11.69C12.1957 0.512051 12.6828 0.702 13.0553 1.04399C13.4278 1.38598 13.6586 1.85517 13.7022 2.35897L14.3824 10.2177C14.41 10.5369 14.3615 10.858 14.2408 11.1548C14.12 11.4515 13.9306 11.7153 13.6879 11.9245L12.4832 12.962C11.9351 13.4338 11.4741 13.8915 11.1847 14.4345C10.9697 14.8355 10.8034 15.2607 10.6894 15.7012L10.2911 17.2348C10.2288 17.4715 10.1157 17.6918 9.95968 17.8803C9.80363 18.0689 9.60838 18.2212 9.38751 18.3266ZM16.3987 11.6099C16.237 11.617 16.0789 11.5613 15.9573 11.4545C15.8356 11.3477 15.76 11.1981 15.7461 11.0368L14.9346 1.6361C14.9208 1.49611 14.9358 1.35478 14.9785 1.22076C15.0212 1.08673 15.0907 0.962818 15.1829 0.856583C15.2751 0.750349 15.388 0.664024 15.5147 0.602882C15.6414 0.54174 15.7792 0.507065 15.9197 0.500971C16.0603 0.494879 16.2006 0.517498 16.3321 0.567446C16.4636 0.617395 16.5835 0.693624 16.6845 0.791481C16.7856 0.889338 16.8656 1.00676 16.9198 1.13659C16.9739 1.26642 17.001 1.40592 16.9994 1.54658V10.9833C16.9996 11.1452 16.9372 11.3008 16.8252 11.4178C16.7133 11.5347 16.5605 11.603 16.3987 11.6099Z" fill="white"/>
                  </svg>
                </div>
              </div>
              <span v-if="message.time" class="message-time">{{message.time}}</span>
            </div>
          </div>
          <div class="chat-message loader-message" v-if="processing">
            <div class="logo">
              <img v-if="hasChatIcon" :src="getChatIcon" />
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                <g clip-path="url(#clip0_1844_66)">
                  <path d="M2.83203 0H12.4919C13.2423 0.0021472 13.9614 0.301211 14.492 0.831855C15.0227 1.3625 15.3217 2.08159 15.3239 2.83203V9.0625C15.3217 9.81294 15.0227 10.532 14.492 11.0627C13.9614 11.5933 13.2423 11.8924 12.4919 11.8945H7.67578L3.44401 15.5339C3.3416 15.6208 3.2089 15.6636 3.07498 15.653C2.94106 15.6423 2.81683 15.579 2.72949 15.4769C2.68562 15.4277 2.65196 15.3703 2.63044 15.308C2.60893 15.2457 2.6 15.1797 2.60417 15.1139L2.82552 11.8945C2.07621 11.8907 1.35878 11.5908 0.829545 11.0604C0.300305 10.5299 0.0021371 9.81182 0 9.0625L0 2.83203C0.0021472 2.08159 0.301211 1.3625 0.831855 0.831855C1.3625 0.301211 2.08159 0.0021472 2.83203 0ZM10.8431 5.06836C11.0362 5.06836 11.2251 5.12563 11.3856 5.23294C11.5462 5.34025 11.6714 5.49276 11.7453 5.67121C11.8192 5.84965 11.8386 6.04601 11.8009 6.23544C11.7632 6.42487 11.6702 6.59888 11.5336 6.73546C11.3971 6.87203 11.2231 6.96504 11.0336 7.00272C10.8442 7.0404 10.6478 7.02106 10.4694 6.94715C10.2909 6.87323 10.1384 6.74807 10.0311 6.58747C9.92381 6.42688 9.86654 6.23807 9.86654 6.04492C9.86654 5.78592 9.96942 5.53753 10.1526 5.35439C10.3357 5.17125 10.5841 5.06836 10.8431 5.06836ZM7.66113 5.06836C7.85428 5.06836 8.04309 5.12563 8.20368 5.23294C8.36428 5.34025 8.48944 5.49276 8.56336 5.67121C8.63727 5.84965 8.65661 6.04601 8.61893 6.23544C8.58125 6.42487 8.48824 6.59888 8.35167 6.73546C8.21509 6.87203 8.04109 6.96504 7.85165 7.00272C7.66222 7.0404 7.46586 7.02106 7.28742 6.94715C7.10897 6.87323 6.95646 6.74807 6.84915 6.58747C6.74184 6.42688 6.68457 6.23807 6.68457 6.04492C6.68457 5.78592 6.78746 5.53753 6.9706 5.35439C7.15374 5.17125 7.40213 5.06836 7.66113 5.06836ZM4.48079 5.06836C4.67394 5.06836 4.86275 5.12563 5.02334 5.23294C5.18394 5.34025 5.30911 5.49276 5.38302 5.67121C5.45693 5.84965 5.47627 6.04601 5.43859 6.23544C5.40091 6.42487 5.3079 6.59888 5.17133 6.73546C5.03475 6.87203 4.86075 6.96504 4.67131 7.00272C4.48188 7.0404 4.28552 7.02106 4.10708 6.94715C3.92864 6.87323 3.77612 6.74807 3.66881 6.58747C3.56151 6.42688 3.50423 6.23807 3.50423 6.04492C3.50423 5.78592 3.60712 5.53753 3.79026 5.35439C3.9734 5.17125 4.22179 5.06836 4.48079 5.06836ZM16.6569 4.58008C17.2819 4.70122 17.8455 5.03581 18.251 5.52659C18.6566 6.01737 18.879 6.63384 18.8802 7.27051V13.5091C18.8759 14.2331 18.5859 14.9261 18.0731 15.4373C17.5604 15.9485 16.8666 16.2365 16.1426 16.2386H16.0433L16.2728 19.5589C16.2796 19.6666 16.2447 19.7727 16.1751 19.8551C16.1039 19.9384 16.0025 19.99 15.8932 19.9986C15.784 20.0071 15.6758 19.9719 15.5924 19.9007L11.333 16.1312H5.72428L8.49121 13.3219H14.3506C14.9659 13.3198 15.5554 13.0744 15.9905 12.6393C16.4256 12.2042 16.671 11.6147 16.6732 10.9993V4.76725C16.6732 4.7054 16.6732 4.64355 16.6732 4.58333L16.6569 4.58008ZM12.4919 1.01725H2.83203C2.35112 1.01854 1.89027 1.21015 1.55021 1.55021C1.21015 1.89027 1.01854 2.35112 1.01725 2.83203V9.0625C1.01854 9.54341 1.21015 10.0043 1.55021 10.3443C1.89027 10.6844 2.35112 10.876 2.83203 10.8773H3.40658C3.54091 10.8865 3.66614 10.9485 3.75489 11.0497C3.84364 11.151 3.8887 11.2833 3.88021 11.4176L3.7028 13.9714L7.13053 11.0254C7.22582 10.9309 7.35443 10.8777 7.48861 10.8773H12.4919C12.9725 10.8751 13.4329 10.6833 13.7727 10.3434C14.1126 10.0035 14.3045 9.54315 14.3066 9.0625V2.83203C14.3045 2.35138 14.1126 1.89103 13.7727 1.55115C13.4329 1.21128 12.9725 1.01939 12.4919 1.01725Z" fill="black"/>
                </g>
                <defs>
                  <clipPath id="clip0_1844_66">
                    <rect width="18.8786" height="20" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="d-flex flex-column">
              <span class="message-text">
                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="20" viewBox="0 0 29 10">
                  <circle class="dot" cx="4.5" cy="5.5" r="2.5" fill="#5A5A5A"/>
                  <circle class="dot" cx="14.5" cy="4.5" r="2.5" fill="#5A5A5A"/>
                  <circle class="dot" cx="24.5" cy="5.5" r="2.5" fill="#5A5A5A"/>
                </svg>
              </span>
            </div>
          </div>
        </div>
        <div class="chatbot-widget__fixed chatbot-widget__footer">
          <b-form-textarea
            ref="textInput"
            v-model="currentMessage"
            class="form-control message-input"
            :placeholder="botTyping ? '' : 'Start typing...'"
            @keypress.enter.exact="sendMessage()"
            :disabled="botTyping"
          />
          <div class="send-icon" @click.stop="sendMessage()">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <path d="M10.6791 10.6642L4.40244 11.71C4.33028 11.722 4.26256 11.7529 4.2061 11.7994C4.14963 11.8459 4.10641 11.9065 4.08078 11.975L1.91661 17.7733C1.70994 18.3067 2.26744 18.815 2.77911 18.5583L17.7791 11.0583C17.8828 11.0064 17.97 10.9266 18.0309 10.8279C18.0918 10.7292 18.1241 10.6156 18.1241 10.4996C18.1241 10.3836 18.0918 10.2699 18.0309 10.1713C17.97 10.0726 17.8828 9.9928 17.7791 9.94084L2.77911 2.44083C2.26744 2.185 1.70994 2.69333 1.91661 3.22583L4.08161 9.02417C4.10724 9.09269 4.15047 9.15326 4.20693 9.19978C4.2634 9.24629 4.33112 9.27712 4.40328 9.28917L10.6799 10.335C10.7191 10.3413 10.7547 10.3613 10.7805 10.3914C10.8062 10.4216 10.8203 10.4599 10.8203 10.4996C10.8203 10.5392 10.8062 10.5776 10.7805 10.6077C10.7547 10.6379 10.7191 10.6579 10.6799 10.6642"/>
            </svg>
          </div>
        </div>
      </template>
      <div v-if="!chatStarted" class="carbon-poweredby"><img :src="require('@/assets/images/powered-by.png')" alt="Powered By SolvPath"></div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable */
import {mapGetters, mapState} from 'vuex'
import AuthToken from '@/components/AuthToken'
import {dateDifference} from '@/utils'
import axios from 'axios'
import {ExternalStepKey} from '@/constants'

export default {
  components: {AuthToken},
  computed: {
    ...mapState(['session', 'campaign', 'token']),
    ...mapGetters(['isSessionUserKnown']),
    hasChatIcon: function() {
      return this.campaign && this.campaign.chatbot_icon
    },
    getChatIcon: function() {
      if (this.hasChatIcon) {
        return this.campaign.chatbot_icon.file
      }
      return null
    },
    quickLinks: function() {
      return this.campaign && this.campaign.quick_links
    },
    baseUrl: function() {
      return process.env.VUE_APP_CHAT_BOT_URL || 'http://localhost:4200/'
    },
    params: function(){
      return {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.token}`
        }
      }
    }
  },
  data() {
    return {
      messages: [{
        text: "<div><p>Hi there! How may I help you?</p></div>", // Initial greeting message
        sentAt: new Date(),
        isUser: false,
      }],
      currentMessage: '',
      processing: false,
      $timeInterval: null,
      chatStarted: false,
      botTyping: false
    };
  },
  methods: {
    toggleChatbot: function() {
      this.chatStarted = !this.chatStarted
      if (this.chatStarted) {
        this.scrollToBottom()
        this.calculateTime()
        this.$timeInterval = setInterval(() => this.calculateTime(), 60000)
      } else {
        clearInterval(this.$timeInterval)
        this.$timeInterval = null
      }
      this.$root.$emit('chat-started', this.chatStarted)
    },
    messageEnd: function(index, id) {
      this.messages[index].id = id.replace(/[^0-9]/g, '')
      this.messages[index].text = this.messages[index].text
        .replaceAll('#$#', '')
        .replaceAll(/ MESSAGE_ID:[0-9]\d+ /gm, '')
        .replaceAll('{brand}.solvpath.com', window.location.host)
      this.messages[index].text += '</p></div>'
    },
    openLink: function(quickLink) {
      if (quickLink) {
        this.$store.commit('busy')
        axios.post('/faq_chat/quick_link/', {quick_link: quickLink.id}).then(() => {
          if (quickLink.step_key === ExternalStepKey) {
            window.open(quickLink.link, '_blank')
          } else {
            window.location.href = quickLink.link
          }
          this.$store.commit('ready')
        }, () => {
          this.$store.commit('ready')
        })
      }
    },
    sendMessage() {
      if (this.processing || !this.currentMessage || this.currentMessage.trim() === "") return;
      this.processing = true
      this.botTyping = true
      const userMessage = {
        isUser: true,
        time: 'Just now',
        sentAt: new Date(),
        text: this.currentMessage
      }

      this.messages.push(userMessage);
      this.scrollToBottom()
      this.$root.$emit('user-replied')
      const url = this.baseUrl + 'v1/chats'

      fetch(url, {
        ...this.params,
        body: JSON.stringify({
          "parent_session_id": this.session.parent_session_id || this.session.id,
          "session_id": this.session.id,
          "campaign_id": this.campaign.id,
          "account_id": this.campaign.account_id,
          "question": this.messages[this.messages.length - 1].text
        })
      }).then(async (response) => {
        if (response.ok) {
          this.processing = false
          const index = this.messages.length
          const reader = response.body.getReader()
          let responseCompleted = false
          let enableLinkText = false
          let enableLinkUrl = false
          let linkUrl = ''
          let linkText = ''
          let messageId = ''

          while (true) {
            const { done, value } = await reader.read()

            if (value && value.length > 0) {
              this.processing = false

              for(let i = 0; i < value.length; i++) {
                if (!responseCompleted) {
                  let newMessage = ""
                  if (value[i] === 10 && value[i - 1] && value[i - 1] !== 10) {
                    newMessage += '<br>'
                  } else {
                    if (value[i] === 91 || value[i] === 93) {
                      enableLinkText = value[i] === 91
                      continue
                    } else if (value[i] === 40 || value[i] === 41) {
                      enableLinkUrl = value[i] === 40
                      continue
                    }

                    if (enableLinkUrl || enableLinkText) {
                      if (enableLinkText) {
                        linkText += String.fromCharCode.apply(null, [value[i]])
                      }
                      if (enableLinkUrl) {
                        linkUrl += String.fromCharCode.apply(null, [value[i]])
                      }
                      continue
                    } else if (linkText && linkUrl) {
                      newMessage += `<a target="_blank" href="${linkUrl}">${linkText}</a>`
                      if (value[i] === 10) {
                        newMessage += '<br><br>'
                      } else {
                        newMessage += String.fromCharCode.apply(null, [value[i]])
                      }
                      linkUrl = ''
                      linkText = ''
                      enableLinkText = enableLinkUrl = false
                      newMessage += '<br>'
                    } else {
                      if (value[i] === 35 && value[i+1] === 36 && value[i+2] === 35) {
                        responseCompleted = true
                      } else
                      if (value[i] === 226 && value[i+1] === 128 && (value[i+2] === 156 || value[i+2] === 157)) {
                        newMessage += '"'
                        i = i + 2
                      } else {
                        newMessage += String.fromCharCode.apply(null, [value[i]])
                      }
                    }
                  }
                  newMessage = newMessage.replaceAll('{brand}.solvpath.com', window.location.host)
                  await this.appendMessage(index, newMessage)
                } else {
                  messageId += String.fromCharCode.apply(null, [value[i]])
                }
              }
            }
            if (done || responseCompleted) {
              this.messageEnd(index, messageId)
              this.$root.$emit('chatbot-replied')
              return;
            }
          }
        } else {
          if (response.status === 401) {  // user token is invalid
            this.$store.commit('logout')
            this.$emit('close')
          } else {
            this.messages.push({
              isUser: false,
              time: 'Just now',
              sentAt: new Date(),
              text: "Sorry, we are unable to understand your query. Please try again",
            })
            this.$root.$emit('chatbot-replied')
          }
        }
      }).catch((error)=> console.error(error))
        .finally(() => {
          this.$refs && this.$refs.textInput && this.$refs.textInput.focus()
          this.processing = false
          this.botTyping = false
          localStorage.setItem('chat', JSON.stringify(this.messages))
        })
    },
    sendMessageFeedback(message, rating) {
      if (message.feedback === rating) {
        return
      }
      const url = this.baseUrl + 'v1/feedback'
      const updateMessageIndex = this.messages.findIndex((updateMessage) => updateMessage.id === message.id)
      this.messages[updateMessageIndex].feedback = rating
      this.messages = [...this.messages]

      fetch(url, {
        ...this.params,
        body: JSON.stringify({
          "session_id": this.session.id,
          "message_id": +message.id,
          "rating": rating === 0 ? 'thumbs-down' : 'thumbs-up',
          "feedback": ""
        })
      }).then(async (response) => {
        if (response.ok) {
          if (updateMessageIndex > -1) {
            this.messages[updateMessageIndex].feedback = rating
          }
        }
      }).catch((error)=> console.error(error))
        .finally(() => {
          localStorage.setItem('chat', JSON.stringify(this.messages))
        })
    },
    calculateTime: function() {
      this.messages.forEach((message, index) => {
        if (index !== this.messages.length - 1 && this.messages[index].isUser === this.messages[index + 1].isUser) {
          this.messages[index].time = null
          this.messages[index].sentAt = null
        }
        if (message.sentAt) {
          const {diffInMinutes, diffInHours} = dateDifference(message.sentAt, new Date())
          if (diffInHours > 0) {
            message.time = `${diffInHours}h ago`
          } else {
            message.time = diffInMinutes === 0 ? 'Just now' : `${diffInMinutes}m ago`
          }
        }
      })
    },
    scrollToBottom: function() {
      setTimeout(() => {
        if (this.$refs && this.$refs.messagesContainer) {
          this.$refs.messagesContainer.lastElementChild.scrollIntoView({behavior: 'smooth'})
        }
        this.currentMessage = ''
      }, 100)
    },
    goBack: function() {
      this.chatStarted = false
      localStorage.removeItem('chat')
    },
    appendMessage: async function(index, newMessage) {
      if (this.messages[index]) {
        this.messages[index].text += newMessage
      } else {
        this.messages.push({
          isUser: false,
          time: 'Just now',
          sentAt: new Date(),
          text: '<div><p>' + newMessage
        })
      }
      // for typing animation, don't remove it
      await new Promise(r => setTimeout(r, 30));
      this.scrollToBottom()
    },
    sendInactivityMessage: function(text) {
      const index = this.messages.length
      for (let i = 0; i < text.length; i++) {
        this.appendMessage(index, text[i])
      }
      this.calculateTime()
      this.appendMessage(index, '</p></div>')
      localStorage.setItem('chat', JSON.stringify(this.messages))

    }
  },
  beforeDestroy() {
    if (this.$timeInterval) {
      clearInterval(this.$timeInterval)
      this.$timeInterval = null
    }
    this.$root.$off('inactivity-message')
  },
  created() {
    const messages = localStorage.getItem('chat')
    if (messages) {
      this.messages = JSON.parse(messages)
    }
    this.$root.$on('inactivity-message', this.sendInactivityMessage)
  }
};
</script>

<style scoped lang="less">

  @keyframes typing {
    0% {
      opacity: 0.2;
      transform: translateY(0);
    }
    50% {
      opacity: 1;
      transform: translateY(-5px);
    }
    100% {
      opacity: 0.2;
      transform: translateY(0);
    }
  }

  .dot {
    animation: typing 1s infinite;
  }

  .dot:nth-child(1) {
    animation-delay: 0s;
  }

  .dot:nth-child(2) {
    animation-delay: 0.2s;
  }

  .dot:nth-child(3) {
    animation-delay: 0.4s;
  }

  .visible {
      top: auto;
  }

  .opacity-0 {
    opacity: 0;
  }

  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
  }

  .header-icon {
    display: flex;
    width: 35px;
    height: 35px;
    padding: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 40px;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.10);
    position: absolute;
    left: 20px;

    &.close-icon {
      right: 20px;
      left: auto;
    }
  }

  .chatbot-widget {
    z-index: 1;
    display: flex;
    position: fixed;
    overflow: auto;
    flex-direction: column;
    background-color: #FFFFFF;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;

    &.chat-started {
      overflow: auto;
    }

    @media only screen and (min-width: 575px) {
      border-radius: 20px;
      bottom: 110px;
      left: calc(100vw - 410px);
      top: unset;
      right: 0;
      width: 375px;
      flex-shrink: 0;
      box-shadow: 0 4px 10px 4px rgba(0, 0, 0, 0.05);
      max-height: 650px;

      &.chat-started {
        height: 540px;
      }

    }

    &.logged-in {
      @media only screen and (min-width: 575px) {
        bottom: 170px;
      }
    }

    &__fixed {
      left: 0;
      right: 0;
      width: 100%;
      padding: 20px;
      position: fixed;

      @media only screen and (min-width: 575px) {
        left: calc(100vw - 410px);
        width: 375px;
      }
    }

    &__header {
      min-height: 64px;
      display: flex;
      flex-shrink: 0;
      padding: 15px;
      align-items: center;
      justify-content: space-between;
      color: #FFFFFF;
      z-index: 6;
      background: var(--theme_color);
      position: fixed;
      width: inherit;

      @media only screen and (min-width: 360px) {
        padding: 15px 20px;
      }

      @media only screen and (min-width: 575px) {
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;
      }

      &__left {
        display: flex;
        align-items: center;
        gap: 15px;
        flex: 1 0 0;
        color: #FFFFFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;

        &__icon {
          width: 52px;
          height: 52px;
          padding: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #FFFFFF;
          border-radius: 50px;

          img {
            width: 100%;
            object-fit: contain;
          }
        }

      }
    }

    &__sub_header {
      display: flex;
      flex-shrink: 0;
      flex-direction: column;
      padding: 0 20px 50px;
      color: #FFFFFF;
      background: var(--theme_color);
      gap: 10px;
      margin-top: 80px;

      &__title {
        color: #FFF;
        font-size: 34px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      &__description {
        color: #FFF;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
        max-width: 350px;
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      align-self: stretch;
      width: calc(100% - 40px);
      margin: -31px auto 75px;

      &__quicklinks {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        border-radius: 5px;
        background: #FFF;
        box-shadow: 0 2px 4px 0 rgba(24, 24, 24, 0.14);

        .chatbot-widget__content__quicklink {
          width: 100%;
          padding: 15px;
          display: flex;
          flex-direction: row;
          align-items: center;
          cursor: pointer;

          &.heading {
            background: #FAFAFA;
            padding: 15px;
          }

          &__img {
            width: 33px;
            height: 38px;
            margin-right: 10px;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          &__left {
            display: flex;
            flex-direction: column;
            gap: 4px;
            flex: 1;

            &__title {
              color: #181818;
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;

              &.top-title {
                font-size: 16px;
                line-height: 21px;
              }

              &.bottom-title {
                font-size: 15px;
              }
            }

            &__subtitle {
              color: #86969C;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }
          }

          &__right {
            svg.message-icon {
              path {
                fill: var(--theme_color);
              }
            }
          }
        }

        > hr:last-child {
          display: none;
        }

        hr {
          width: calc(100% - 30px);
          border-color: #E6E6E6;
          margin: 0 auto;
        }
      }
    }

    .carbon-poweredby {
      padding: 10px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
      background: #FAFAFA;
      width: inherit;
      text-align: center;
      position: fixed;
      bottom: 0;

      img {
        height: 20px;
        object-fit: contain;
      }

      @media only screen and (min-width: 575px) {
        border-bottom-right-radius: 20px;
        border-bottom-left-radius: 20px;
        bottom: 110px;
      }
    }

    &__body {
      display: flex;
      flex-direction: column;
      justify-content: safe flex-end;
      padding: 20px 20px 0;
      background: #FFFFFF;
      flex: 1 1 100%;
      position: absolute;
      top: 64px;
      left: 0;
      right: 0;
      overflow-y: auto;
      height: calc(100% - 85px - 51px);
    }

    &__footer {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      background: #FFFFFF;
      z-index: 5;
      padding-top: 0;

      @media only screen and (min-width: 575px) {
        border-bottom-right-radius: 20px;
        border-bottom-left-radius: 20px;
      }

      > div {
        display: flex;
        padding: 20px;
        position: fixed;
      }

      .message-input {
        display: flex;
        width: 100%;
        padding: 15px 45px 15px 15px;
        justify-content: space-between;
        align-items: center;
        border-radius: 10px;
        border: 1px solid #E6E6E6;
        background: #FAFAFA;
        color: #A39C9C;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 19px; /* 150% */
        height: 51px !important;
        resize: none;

        @media only screen and (min-width: 576px) {
          font-size: 14px;
        }
      }

      .send-icon {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        position: absolute;
        right: 36px;
        top: 16px;
        z-index: 2;
        padding: 0;
        cursor: pointer;

        svg {
          path {
            fill: var(--theme_color);
          }
        }
      }
    }
  }
</style>
